import { apiClient } from '../client/apiClient';

export type InquiryMessageCache = {
  email?: string | null;
  name?: string | null;
  phone?: string | null;
  text?: string | null;
};

export type InquiryMessageCacheResponse = {
  data?: InquiryMessageCache;
};

export const getInquiryMessageCache = async (): Promise<InquiryMessageCacheResponse> => {
  return apiClient<InquiryMessageCacheResponse>({
    path: '/v2/user/inquiryMessageCache',
  });
};

export const inquiry = {
  getInquiryMessageCache,
};
